export default "__VITE_ASSET__zYV3PIJX__"